import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ActivityIndicator,
  Dimensions,
  Image,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

const { width, height } = Dimensions.get('window');

export default function LoadingScreen() {
  return (
    <LinearGradient
      colors={['#0F766E', '#134E4A', '#042F2E']}
      style={styles.container}
    >
      
      <View style={styles.appContainer}>
        {/* Logo Section */}
        <View style={styles.logoContainer}>
          <View style={styles.logoWrapper}>
            <Image
              source={require('../../assets/zoolyfe_logo.svg')}
              style={styles.logoImage}
              resizeMode="contain"
            />
          </View>
          <View style={styles.clubTextContainer}>
            <Image
              source={require('../../assets/club_text.png')}
              style={styles.clubImage}
              resizeMode="contain"
            />
          </View>
          
          {/* Loading spinner */}
          <ActivityIndicator 
            size="large" 
            color="#F8FAFC" 
            style={styles.loader}
          />
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  ellipse1: {
    position: 'absolute',
    width: 526,
    height: 526,
    borderRadius: 263,
    left: -236,
    top: -178,
    backgroundColor: '#67E8F9',
    opacity: 0.3,
  },
  ellipse2: {
    position: 'absolute',
    width: 310,
    height: 310,
    borderRadius: 155,
    right: -145,
    bottom: 162,
    backgroundColor: '#818CF8',
    opacity: 0.25,
  },
  appContainer: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  logoContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  logoWrapper: {
    marginBottom: 0,
  },
  logoImage: {
    width: 293,
    height: 64,
  },
  clubTextContainer: {
    alignItems: 'center',
    marginTop: 0,
  },
  clubImage: {
    width: 120,
    height: 80,
  },
  loader: {
    marginTop: 40,
  },
});